<template>
  <div>
    <populate-form
      formTitle="劃位邀約確認管理"
      collapseStyle="simple"
      fkey="pe01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="negotiateList"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button class="mb-1 mr-1" v-for="action in row.item.actions_to_take" :key="action.negotiate_id" @click="callProcess(action.value,row.item)">
          {{action.text}}
        </b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowOffer" 
      centered
      size="lg"
      hide-header
      hide-footer
      :static="true"
    >
      <StoreOfferNegotiate ref="offerNegotiate" :doneCB="finishOffer" />
    </b-modal>
  </div>
</template>

<script>

import StoreOfferNegotiate from "./SubComponent/StoreOfferNegotiate"

export default {
  name: 'StoreApplyManage',
  components:{
    StoreOfferNegotiate,
  },
  props: {
    
  },
  data: function () {
    return {
      modalShowOffer:false,
      service_minute_unit:30,
      negotiateList:[],
      fields:[
        {
          key:'actions',
          label:'操作'
        },
        {
          key:'reserve_start_time',
          label:'目標時間'
        },
        {
          key:'reply_time',
          label:'確認時間'
        },
        {
          key:'msg',
          label:'請求訊息'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'b-form-select',
          akey:'status',
          col:6,
          defaultValue:'',
          //選項選重新建議或已過期時就不會有提議取消的結果喔
          dataOptions:[{text:'全部申請狀態',value:''},{text:'待確認中',value:'valid'},{text:'已被同意接受',value:'committed'},{text:'已被拒絕',value:'rejected'},{text:'已被重新建議',value:'resuggested'},{text:'提議已抽回',value:'cancelled'},{text:'已過期失效',value:'expired'}]
        },
        {
          componentType:'b-form-select',
          akey:'from_type',
          col:6,
          defaultValue:'both',
          dataOptions:[{text:'全部發起方',value:'both'},{text:'店家邀約',value:'store'},{text:'用戶申請',value:'user'}]
        },
        {
          componentType:'b-form-select',
          akey:'filter_time_target',
          col:3,
          defaultValue:'send_time',
          dataOptions:[{text:'依申請時間',value:'send_time'},{text:'依時段開始時間',value:'start_time'}]
        },
        {
          componentType:'date-picker',
          akey:'filter_date_s',
          defaultValue:'',
          col:2,
          placeholder:'篩選起始日'
        },
        {
          componentType:'date-picker',
          akey:'filter_date_e',
          defaultValue:'',
          col:2,
          placeholder:'篩選結束日'
        },
        {
          componentType:'btn-group',
          col:5,
          buttons:[
            {
              col:3,
              placeholder:'篩選',
              execCallback:this.searchApplys
            },
            {
              col:2
            },
            {
              col:3,
              placeholder:"邀約",
              execCallback:this.openOfferInvite
            }
          ]
        },
      ],
    }
  },
  methods: {
    finishOffer() {
      this.searchApplys()
      this.modalShowOffer = false
    },
    openOfferInvite() {
      // 剛打開一律回到列表查票模式,不要停在剛剛殘留的尚未送出的邀請介面(那張票可能也已不能邀請了)
      this.$refs.offerNegotiate.OpState = 'TicketList'
      this.modalShowOffer = true
    },
    callProcess(action, data) {
      switch(action) {
        case 'cancel_offer':
          this.cancelOffer(data)
          break
        case 'confirm_accept':
          this.confirmAccept(data)
          break
        case 'confirm_reject':
          this.confirmReject(data)
          break
        case 'browse_resuggest':
          this.browseResuggest(data)
          break
        case 'cancel_cancel_request':
          this.cancelCancelRequest(data)
          break
        case 'accept_in_harmony':
          this.acceptInHarmony(data)
          break
        case 'accept_in_peach':
          this.acceptInPeach(data)
          break
        case 'accept_in_trouble':
          this.acceptInTrouble(data)
          break
      }
    },
    cancelOffer(data) {
      let Param = {
        module:'store',
        method:'cancelReservationOfferByStore',
        negotiation_id:data.negotiate_id
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.$bus.fnShowInfo("抽回成功")
        vm.searchApplys()
      }, this)
    },
    confirmAccept(data) {
      let Param = {
        module:'store',
        method:'confirmReservationApplyByStore',
        negotiation_id:data.negotiate_id,
        new_status:'committed',
        resuggest_plot_id:0,
        reply_remark:'直接確認接受了'
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.$bus.fnShowInfo("已確認接受")
        vm.searchApplys()
      }, this)
    },
    confirmReject(data) {
      let Param = {
        module:'store',
        method:'confirmReservationApplyByStore',
        negotiation_id:data.negotiate_id,
        new_status:'rejected',
        resuggest_plot_id:0,
        reply_remark:'因故直接委婉拒絕了'
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.$bus.fnShowInfo("已確認回絕")
        vm.searchApplys()
      }, this)
    },
    cancelCancelRequest(data) {
      this.$bus.fnShowConfirm("確認取消這個取消劃位的通知並仍保留此劃位？", ()=>{
        let Param = {
          module:'store',
          method:'cancelReservationCancellationByStore',
          negotiation_cancel_id:data.negotiate_id,//此處的negotiate_id是negotiate_cancel.id
          new_status:'committed',
          resuggest_plot_id:0,
          reply_remark:'直接確認接受了'
        }
        this.$bus.apiCall(Param, function(data, vm) {
          if (data.ok === 0) {
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo(data.msg)
            return
          }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("已抽回取消劃位通知")
          vm.searchApplys()
        }, this)
      })
    },
    browseResuggest(item) {
      let go_param = {}
      let Param = {}
      if (item.reservation_result_id) {
        Param = {
          'module':'store',
          'method':'getStoreReservationById',
          'reservation_result_id': item.reservation_result_id
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok == 0) {
            vm.$bus.fnShowInfo("讀取預約紀錄失敗:"+data.msg)
            return
          }
          go_param.reservation_id = data.data.id
          go_param.data = data.data
          go_param.data.mwct_id = 0
          vm.$bus.linkCallStack = [
            {landingComponent:vm.$options._componentTag,params:{}},
            {landingComponent:'StoreRcManage',params:go_param}
          ]
          vm.$bus.landingComponent = "StoreRcManage"
        },this)
      }
      else if (item.negotiate_id) {
        Param = {
          'module':'store',
          'method':'getNegotiateById',
          'negotiation_id': item.negotiate_id
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok == 0) {
            vm.$bus.fnShowInfo("讀取劃位申請紀錄失敗:"+data.msg)
            return
          }
          go_param.negotiation_id = item.negotiate_id
          go_param.data = data.data
          vm.$bus.linkCallStack = [
            {landingComponent:vm.$options._componentTag,params:{}},
            {landingComponent:'StoreRcManage',params:go_param}
          ]
          vm.$bus.landingComponent = "StoreRcManage"
        },this)
      }

    },
    acceptInHarmony(data) {
      this.confirmCancel(data,'in_harmony')
    },
    acceptInPeace(data) {
      this.confirmCancel(data,'in_peace')
    },
    acceptInTrouble(data) {
      this.confirmCancel(data,'in_trouble')
    },
    confirmCancel(data, choice) {
      // 這個需要一個modal來讓操作者可以填寫備註,晚點再補
      let Param = {
        module:'store',
        method:'confirmReservationCancelByStore',
        negotiation_cancel_id:data.negotiate_id,
        cancel_status:choice,
        reply_remark:''
      }
      this.$bus.apiCall(Param, function(data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        vm.$bus.fnShowInfo("已回覆確認完成")
        vm.searchApplys()
      }, this)
    },
    jumpView() {
      // 跳到每日預約檢視,到此日期並把標的時段highlight起來
      // 建議改預約時段的串接先不做,確認需要再提供



    },
    filterChanged(upd) {
      if (['status','form_type','filter_time_target'].includes(upd.key)) {
        setTimeout(() => {
          this.searchApplys()
        }, 100);
      }
    },
    searchApplys() {
      let Param = {
        'module':'store',
        'method':'getNegotiateList',
        'store_id': this.$bus.session.merchant_store_id,
        'status': this.filterData.status,
        'from_type':this.filterData.from_type,
        'filter_time_target':this.filterData.filter_time_target,
        'filter_date_s':this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        'filter_date_e':this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        'page_number':1,
        'items_per_page':500
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.negotiateList = data.data
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    this.filterData.filter_date_s = this.getDateByStr('',-30,'-')
    this.filterData.filter_date_e = this.getDateByStr('',0,'-')
    this.$refs.filterForm.refreshModelVar('filter_date_s,filter_date_e')
    setTimeout(() => {
      this.searchApplys()
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
